var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"accept":_vm.accept,"before-upload":_vm.beforeUpload,"show-upload-list":_vm.showUploadList}},'a-upload',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }